module.exports = __webpack_public_path__ + "img/72.628cf343.png";